module.exports = __webpack_public_path__ + "media/application/images/ui/purchase/consumer-online-b72aacdc291dbcf50cc762f10d25089d.png";